import { useMemo } from 'react';

// Redux
import { useDispatch, useSelector } from 'react-redux';

import {
  setColumnVisibility,
  setLimit,
  setPage,
  setTotal,
  setFailedSendCreditTransactionsTableFilters,
  setClearFailedSendCreditTransactionsTableFilters,
} from '@Modal/reducers/failedSendCreditTransactionsTableSlice/failedSendCreditTransactionsTableSlice';

// Types
import { StoreInterface } from 'src/app/types';
import { FilterItemType } from '@Modal/reducers/types';

export const useFailedSendCreditTransactionsTable = () => {
  const dispatch = useDispatch();
  const {
    selectedFilters,
    columnVisibility,
    columnVisibilityOptions,
    page,
    limit,
    total,
    failedSendCreditTransactionsTableFilters,
  } = useSelector((state: StoreInterface) => state?.failedSendCreditTransactionsTable);

  const failedSendCreditTransactionsListFilters = useMemo(() => {
    const columnVisibilityStrArr = Array.from(Object.values(columnVisibility)).map((filt) => filt);
    return columnVisibilityStrArr as string[];
  }, [columnVisibility]);

  const handleApplyColumnVisibility = (column: string[]) => {
    const newVisibleColumns = [...failedSendCreditTransactionsListFilters, ...column];
    if (failedSendCreditTransactionsListFilters.filter((col) => column.includes(col)).length > 0) {
      const filteredNewVisibleColumns = failedSendCreditTransactionsListFilters.filter(
        (col) => col !== column[0]
      );
      dispatch(setColumnVisibility(filteredNewVisibleColumns));
    } else {
      dispatch(setColumnVisibility(newVisibleColumns));
    }
  };

  const visiblityCustomizable = useMemo(
    () => ({
      value: columnVisibility,
      options: columnVisibilityOptions,
      apply: (value: string[]) => handleApplyColumnVisibility(value),
    }),
    [columnVisibility, columnVisibilityOptions]
  );

  const handleFilterSelect = (filter: FilterItemType) => {
    dispatch(setFailedSendCreditTransactionsTableFilters(filter));
  };

  const clearRoundTableFiltersHandler = () => {
    dispatch(setClearFailedSendCreditTransactionsTableFilters());
  };

  return {
    // State
    page,
    limit,
    total,
    selectedFilters,
    columnVisibility,
    visiblityCustomizable,
    columnVisibilityOptions,
    failedSendCreditTransactionsListFilters,
    failedSendCreditTransactionsTableFilters,
    // Actions
    setLimit,
    setPage,
    setTotal,
    setFailedSendCreditTransactionsTableFilters,
    // Handlers
    handleFilterSelect,
    handleApplyColumnVisibility,
    clearRoundTableFiltersHandler,
  };
};
